import { isProd } from '~/util'

export const state = () => ({
  // This array indicates which flags were detected and set.  This can be
  // great for tracking, or persisting flags through a session
  updated_flags: [],
  enable_upgrade: true,
  persist_id: false,
  enable_editor_history: true,
  show_pricing_faqs: true,
  enable_containers: false,
  enable_eid_notes: true,
  enable_i18n: false,
  enable_fabric: true,
  enable_template_options: true,
  skip_editor_ideas: false,
  enable_cloud_uploads: true,
  enable_package_nav_grid: true,
  enable_template_align: false,
  enable_account_sub_in_flow: true,
  enable_website_addons_in_flow: false,
  iconfinder_icons: false,
  enable_background_shapes: true,
  iframe_mode: false,
  enable_email_signatures: true,
  show_monthly_pricing_first: true,
  simple_shapes: true,
  new_shapes: false,
  editor_start_with_colors: true,
  enable_enhanced_flow: true,
  enable_standalone_ideas: true,
  enable_brand_profile: true,
  enable_free_logos: true,
  enable_multi_currency_and_language: true,
  enable_notifications: true,

  /**
   * The priority is: v1 > v2 > v3 when multiple are enabled.
   * When none are enable, it is default to the original version.
   * v2_initial allows v2 to show upon arriving dashboard
   * and has no interference with the v1/v2/v3 being enabled.
   * v2_initial must not enabled when upgrade-prompt modal is in effect.
   */
  enable_upgrade_modal_v1: false,
  enable_upgrade_modal_v2: false,
  enable_upgrade_modal_v3: false,
  enable_upgrade_modal_v2_initial: false,

  enable_stitch_edge: true,

  // When true, skipping the logo type page will send the user past keywords
  enable_skip_keywords_on_skip: false,

  // This value can be a string, or an array of strings.
  enable_auth_prompt: false,

  // Where possible, the user may be able to opt out of registration.
  enable_optional_auth: true,
  client_side_logos: true,
  new_industries_list: false,
  enable_domains: true,
  enable_post_save_flow: false,
  enable_progress_tracker: true,
  enable_big_social_login: false,
  enable_delete_site_btn: false,
  enable_delete_account: false,
  // Send the user from the logo type page to ideas
  enable_skip_icons: false,
  default_icon_set: true,
  enable_agency_modal: true,
  enable_three_column_ideas: true,
  enable_ideas_banner_card: false,
  enable_one_page_site_creation: true,
  force_show_upgrade_prompt: false,
  stripe_setup_confirm: true,
  enable_multiple_one_page_sites: false,
  enable_api_deduplication: false,
  enable_one_page_sites_downgrade: false,
  script_controls: true,
  icon_auto_search: true,
  enable_1ps_meta_button: false,
  enable_1ps_maps: true,
  enable_1ps_map_search: true,
  domain_forwarding_status: false,
  enable_gradients: true,
  enable_stitch_edge_email_signature: true,
  ideas_gradients: !isProd(),
  enable_1ps_custom_colors: true,
  enable_1ps_button_styles: true,
  name_on_checkout: true,
  enable_1ps_fonts: true,
  new_palette_colors: !isProd(),
  enable_1ps_background_images: true,
  dashboard_search_logos: !isProd(),
  baremetrics_survey: true,
  enable_1ps_social_icons: true,
  enable_business_email: true,
})

export const flags = Object.keys(state())

export const mutations = {
  update(state, { flag, value }) {
    state[flag] = value

    state.updated_flags.push(flag)
  },
}
